import { render, staticRenderFns } from "./SubmissionList.vue?vue&type=template&id=3003716c&scoped=true&"
import script from "./SubmissionList.vue?vue&type=script&lang=js&"
export * from "./SubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionList.vue?vue&type=style&index=0&id=3003716c&prod&lang=scss&scoped=true&"
import style1 from "./SubmissionList.vue?vue&type=style&index=1&id=3003716c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3003716c",
  null
  
)

export default component.exports